const defaultLevels: Record<App.BusinessTraveller.BusinessBudget['placeType'], number> = {
  global: 1,
  city: 2,
  country: 3,
  region: 4,
}

function sortBudgetByPlaceType(
  budgets: Array<App.BusinessTraveller.BusinessBudget>,
  levels: Record<App.BusinessTraveller.BusinessBudget['placeType'], number> = defaultLevels,
) {
  return budgets.sort((budget1, budget2) => {
    const placeTypeComparison = levels[budget1.placeType] - levels[budget2.placeType]
    // if they have the same place, sort by alphabetical
    if (placeTypeComparison === 0) {
      return budget1.name.localeCompare(budget2.name)
    }

    return placeTypeComparison
  })
}

export default sortBudgetByPlaceType
